import { useEffect } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import * as actions from 'js/components/system/Page/store/actions';

import * as helpers from './helpers';
import { useContainingIdPages } from './useContainingIdPages';

export const usePageAsPopupBackground = ({ isPageInPopup, path, page, pageError }) => {
    const dispatch = useDispatch();
    const { lang, role } = useUserSelector(pick(['lang', 'role']));
    const { rootPage, defaultLocale } = useAppSelector(pick(['rootPage', 'defaultLocale']));
    const hasAccessToPage = page?.permissions[role];
    const containingIdPages = useContainingIdPages();

    useEffect(() => {
        if (isPageInPopup) {
            return;
        }

        if (pageError && pageError.path === path) {
            dispatch(actions.setPopupBackgroundPagePath(rootPage || '/'));
        }

        if (page && (page.url[lang] || page.path === path)) {
            const configuredUrl = page.dynamicPagePath || page.url[lang] || page.url[defaultLocale];
            const pageDynamicId = helpers.getPageDynamicId(page.path, containingIdPages);
            const backgroundPagePath = configuredUrl
                ? `${configuredUrl}${pageDynamicId ? `/${pageDynamicId}` : ''}`
                : path;

            dispatch(actions.setPopupBackgroundPagePath(hasAccessToPage ? backgroundPagePath : rootPage));
        }
    }, [
        dispatch, rootPage, isPageInPopup, page, pageError, lang,
        path, defaultLocale, hasAccessToPage, containingIdPages
    ]);
};
